import React, { Component } from 'react'
import { ListGroup, Table } from 'reactstrap'
import { ManageLicenseRow } from './'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';

class ManageLicenses extends Component {
  state = {
    sort : false,
    sortValue : 'name'
  }
  
  sort(value){
    this.setState({sort : !this.state.sort,
        sortValue : value
    })
  }

  render() {

    const { accountLicenses } = this.props
    const sortedLicenses = sortByPropText(accountLicenses, this.state.sortValue, this.state.sort);
    return (
      <Table responsive>
        <thead>
          <tr>
          <th>Product &nbsp;<i onClick={this.sort.bind(this, 'name')} className={`sort-icon icon-arrow-${this.state.sort  && this.state.sortValue === 'name' ? 'down': 'up'}`}></i></th>
          <th>License Type &nbsp;<i onClick={this.sort.bind(this, 'licenseType')} className={`sort-icon icon-arrow-${this.state.sort && this.state.sortValue === 'licenseType' ? 'down': 'up'}`}></i></th>
          <th>License Quantity &nbsp;<i onClick={this.sort.bind(this, 'licensedMax')} className={`sort-icon icon-arrow-${this.state.sort && this.state.sortValue === 'licensedMax' ? 'down': 'up'}`}></i></th>
          <th>Start Date  &nbsp;<i onClick={this.sort.bind(this, 'startDate')} className={`sort-icon icon-arrow-${this.state.sort && this.state.sortValue === 'startDate' ? 'down': 'up'}`}></i> / End Date &nbsp;<i onClick={this.sort.bind(this, 'endDate')} className={`sort-icon icon-arrow-${this.state.sort && this.state.sortValue === 'endDate' ? 'down': 'up'}`}></i></th>
          <th>Actions</th>
          </tr>
        </thead>
        
      <tbody>
        {sortedLicenses.map((license) => 
          <ManageLicenseRow
            key={license.id}
            license={license}
          />  
        )}
      </tbody>
      </Table>
    )
  }
}


export default ManageLicenses


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/ManageLicenses.js